module.exports = __webpack_public_path__ + "img/11_73.0e90b194.png";